import { Component } from 'react';
import { connect } from 'react-redux';

import * as surveyEvents from '../../constants/events';
import { loadResponses } from '../../store/actions/responses';

import {
  setProjectLogo,
  removeProjectLogo,
  changeProjectImageSize,
  alignProjectLogo,
  changeLogoBackgroundColor,
  setProjectBackgroundImage,
  setProjectBackgroundImageOpacity,
  toggleBackgroundImageTiled,
  removeBackgroundImage,
  changeBackgroundColor,
  changePrimaryColor,
  alignQuestionsText,
  changeQuestionColor,
  changeQuestionFont,
  changeAnswersColor,
  changeAnswersFont,
} from '../../store/slices/customization/customization';

const PATH_NAMES_WITH_LISTENERS = ['/preview/', '/viewAnswer/'];

interface DesignEvent {
  data: {
    event: string;
    message: Record<string, unknown>;
  };
}

interface Props {
  surveyLoading: boolean;
}

export class SurveyListener extends Component<Props> {
  constructor(props) {
    super(props);
    this.handler = this.handler.bind(this);
  }

  componentDidMount(): void {
    if (PATH_NAMES_WITH_LISTENERS.some((v) => window.location.pathname.startsWith(v))) {
      window.addEventListener('message', this.handler);
    }
  }

  componentDidUpdate(prevProps): void {
    if (
      prevProps.surveyLoading &&
      !this.props.surveyLoading &&
      PATH_NAMES_WITH_LISTENERS.some((v) => window.location.pathname.startsWith(v))
    ) {
      // eslint-disable-next-line no-restricted-globals
      parent.postMessage({ event: 'surveyLoaded' }, '*');
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener('message', this.handler);
  }

  handler(event: DesignEvent): void {
    const actionType = event.data.event;
    const data = event.data.message;
    if (actionType in surveyEvents && actionType in this.props) {
      this.props[actionType](data);
    }
  }

  render(): null {
    return null;
  }
}

const mapDispatchToProps = {
  setProjectLogo,
  removeProjectLogo,
  changeProjectImageSize,
  alignProjectLogo,
  changeLogoBackgroundColor,
  setProjectBackgroundImage,
  setProjectBackgroundImageOpacity,
  toggleBackgroundImageTiled,
  removeBackgroundImage,
  changeBackgroundColor,
  changePrimaryColor,
  alignQuestionsText,
  changeQuestionColor,
  changeQuestionFont,
  changeAnswersColor,
  changeAnswersFont,
  loadResponses,
};

const mapStateToProps = (state): { surveyLoading: boolean } => {
  return {
    surveyLoading: state.surveyPreviewLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyListener);
